import * as serviceContext from '../services/serviceContext';
import { REPORTS_ROOT as ReportsURL } from '../configs/api';

var options = {};
var headers = new Headers();

headers.append('Content-Type', 'application/json');
options.headers = headers;

export async function getUserRebateBonus(game, date) {
    try {
        const response = await serviceContext.get("manage/Profile/userrebatebonus", null, options);
        if (response.hasError === true) {
            return false;
        }
        else {
            const res = response.json();
            return res;
        }
    }
    catch (error) {
        return error;
    }
};

